// @flow
import type { Country } from '@tectonics/commons/country/country';
import type { ValidationFunction } from './types';

export type CustomerPhoneNumberValidationConfig = {|
  phoneNumberValidationFunction?: ValidationFunction,
  phoneNumberInputFieldName?: string,
|};

export function getCustomerPhoneNumberConfig(country: ?Country): CustomerPhoneNumberValidationConfig {
  const phoneNumber = country?.customerForm?.phoneNumber;

  return {
    phoneNumberValidationFunction: phoneNumber?.validationFunction,
    phoneNumberInputFieldName: phoneNumber?.inputFieldName,
  };
}
